module.exports = __webpack_public_path__ + "img/filter-regular.1a16bb15.svg";